import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { processLogout } from '../utils';
import { RestDataSource } from '../../utils/RestDataSource';
import { restbaseurl } from '../../globals/constants';

class SessionDialog extends Component {
    constructor(props) {
        super(props);
        this.countdownInterval = null;
        this.state = {
            show: false,
            type: null, // 'concurrent' or 'idle'
            countdown: 15
        };
    }

    componentDidMount() {
        // Listen for session dialog events
        window.addEventListener('showSessionDialog', this.handleShowDialog);
        window.addEventListener('hideSessionDialog', this.handleHideDialog);
    }

    componentWillUnmount() {
        window.removeEventListener('showSessionDialog', this.handleShowDialog);
        window.removeEventListener('hideSessionDialog', this.handleHideDialog);
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
            this.countdownInterval = null;
        }
    }

    handleShowDialog = (event) => {
        const { type, countdown = 15 } = event.detail || {};
        this.setState({ show: true, type, countdown });
        
        if (type === 'idle') {
            // Clear any existing interval
            if (this.countdownInterval) {
                clearInterval(this.countdownInterval);
            }
            // Start countdown for idle timeout
            this.countdownInterval = setInterval(() => {
                this.setState(prevState => {
                    const newCountdown = prevState.countdown - 1;
                    if (newCountdown <= 0) {
                        if (this.countdownInterval) {
                            clearInterval(this.countdownInterval);
                            this.countdownInterval = null;
                        }
                        this.handleLogout();
                        return { countdown: 0 };
                    }
                    return { countdown: newCountdown };
                });
            }, 1000);
        }
    }

    handleHideDialog = () => {
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
            this.countdownInterval = null;
        }
        this.setState({ show: false, type: null, countdown: 15 });
    }

    handleLogout = async () => {
        try {
            // Call logout API
            const dataSource = new RestDataSource(`${restbaseurl}/login/logout`);
            await dataSource.GetData(() => {}, {}, "POST");
        } catch (e) {
            console.error('Error calling logout API:', e);
        } finally {
            // Clear local storage and redirect
            await processLogout();
            window.location.replace('/');
        }
    }


    render() {
        const { show, type, countdown } = this.state;

        if (!show) return null;

        const isConcurrent = type === 'concurrent';
        const isIdle = type === 'idle';

        return (
            <Modal 
                show={show} 
                onHide={this.handleHideDialog}
                backdrop="static"
                keyboard={false}
                centered
                className="session-dialog-modal"
            >
                <Modal.Header className="modal-header">
                    <Modal.Title>
                        <h6>{isConcurrent ? 'Logged in from Another Device' : 'Session Timeout Warning'}</h6>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="modal-body">
                    <div className="session-dialog-content">
                        {isConcurrent ? (
                            <>
                                <div className="alert alert-warning">
                                    <i className="bt-icon bt-alert-triangle" style={{ marginRight: '10px' }}></i>
                                    <strong>Your account has been logged in from another device.</strong>
                                </div>
                                <p>For security reasons, your current session will be logged out.</p>
                                <p>If this wasn't you, please change your password immediately.</p>
                            </>
                        ) : (
                            <>
                                <div className="alert alert-warning">
                                    <i className="bt-icon bt-clock" style={{ marginRight: '10px' }}></i>
                                    <strong>Your session is about to expire due to inactivity.</strong>
                                </div>
                                <p>You will be automatically logged out in <strong>{countdown} seconds</strong>.</p>
                                <p>Click "Stay Logged In" to continue your session.</p>
                            </>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer className="text-center">
                    {isConcurrent ? (
                        <Button 
                            variant="primary" 
                            className="btn btn_primary"
                            onClick={this.handleLogout}
                        >
                            Logout
                        </Button>
                    ) : (
                        <>
                            <Button 
                                variant="secondary" 
                                className="btn btn_secondary"
                                onClick={this.handleLogout}
                            >
                                Logout Now
                            </Button>
                        </>
                    )}
                </Modal.Footer>
            </Modal>
        );
    }
}

export default SessionDialog;

